import { useNavigate } from 'react-router-dom';
import Breadcrumb from '@/components/common/Breadcrumb';

interface UploadType {
  id: string;
  name: string;
  description: string;
  icon: string;
}

const uploadTypes: UploadType[] = [
  {
    id: 'menu',
    name: 'MenuUpload',
    description: '検索メニュー情報のアップロード',
    icon: '🧭',
  },
  {
    id: 'corner',
    name: 'CornerUpload',
    description: 'コーナー情報のアップロード',
    icon: '📐',
  },
  {
    id: 'display',
    name: 'DisplayUpload',
    description: 'ディスプレイ情報のアップロード',
    icon: '📺',
  },
  {
    id: 'special',
    name: 'SpecialUpload',
    description: 'スペシャル情報のアップロード',
    icon: '⭐',
  },
  {
    id: 'special-block',
    name: 'SpecialBlockUpload',
    description: 'スペシャルブロック情報のアップロード',
    icon: '🧩',
  },
  {
    id: 'information',
    name: 'InformationUpload',
    description: 'インフォメーション情報のアップロード',
    icon: 'ℹ️',
  },
  {
    id: 'books',
    name: 'BooksUpload',
    description: '書籍情報のアップロード',
    icon: '📚',
  },
  {
    id: 'products',
    name: 'ProductsUpload',
    description: '商品情報のアップロード',
    icon: '🛍️',
  },
  {
    id: 'coupon',
    name: 'CouponUpload',
    description: 'クーポン情報のアップロード',
    icon: '🎟️',
  },
  {
    id: 'incentive',
    name: 'IncentiveUpload',
    description: 'インセンティブ情報のアップロード',
    icon: '🎁',
  },
  {
    id: 'point',
    name: 'PointUpload',
    description: 'ポイント情報のアップロード',
    icon: '💎',
  },
  {
    id: 'restricted-page',
    name: 'RestricatedPageUpload',
    description: '制限ページ情報のアップロード',
    icon: '🔒',
  },
  {
    id: 'restricted-block',
    name: 'RestricatedBlockUpload',
    description: '制限ブロック情報のアップロード',
    icon: '🚫',
  },
  {
    id: 'trial',
    name: 'TrialUpload',
    description: 'トライアル情報のアップロード',
    icon: '🧪',
  },
  {
    id: 'questionnaire',
    name: 'QuestionnaireUpload',
    description: 'アンケート情報のアップロード',
    icon: '📋',
  },
  {
    id: 'book-point',
    name: '献本ポイントUpload',
    description: '献本ポイント情報のアップロード',
    icon: '📖',
  },
];

const UploadTypeNew = () => {
  const navigate = useNavigate();

  const handleSelectType = (typeId: string) => {
    navigate(`/upload-management/${typeId}`);
  };

  return (
    <div>
      <Breadcrumb />
      <div className="card">
        <h1 className="text-2xl font-bold text-admin-text mb-2">アップロード管理</h1>
        <p className="text-admin-textLight mb-6">
          アップロードするタイプを選択してください
        </p>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4 gap-4">
          {uploadTypes.map((type) => (
            <button
              key={type.id}
              onClick={() => handleSelectType(type.id)}
              className="p-4 border border-gray-200 rounded-lg hover:border-blue-500 hover:shadow-lg hover:bg-blue-50 transition-all duration-200 text-left group"
            >
              <div className="text-4xl mb-3 group-hover:scale-110 transition-transform duration-200">
                {type.icon}
              </div>
              <h3 className="font-semibold text-admin-text mb-1 group-hover:text-blue-600 transition-colors">
                {type.name}
              </h3>
              <p className="text-sm text-admin-textLight group-hover:text-admin-text transition-colors">
                {type.description}
              </p>
            </button>
          ))}
        </div>
      </div>
    </div>
  );
};

export default UploadTypeNew;
